import { render, staticRenderFns } from "./transcripts.component.vue?vue&type=template&id=65561e96&scoped=true&"
import script from "./transcripts.component.vue?vue&type=script&lang=js&"
export * from "./transcripts.component.vue?vue&type=script&lang=js&"
import style0 from "./transcripts.component.vue?vue&type=style&index=0&id=65561e96&scoped=true&lang=scss&"
import style1 from "./transcripts.component.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65561e96",
  null
  
)

export default component.exports